
import { Component, Vue } from "vue-property-decorator";
import AdminTable from "@/components/admin/AdminTable.vue";
import AdminSkinCell from "@/components/admin/AdminSkinCell.vue";
import AdminProviderBadge from "@/components/admin/AdminProviderBadge.vue";
import * as _ from "lodash";
import multipleMutate from "@/mixins/multipleMutate";

@Component({
  components: {
    AdminTable,
    AdminSkinCell,
    AdminProviderBadge
  },
  mixins: [multipleMutate]
})
export default class AdminProviderOfferItem extends Vue {
  selected: any[] = [];

  columns = [
    {
      name: "_id",
      required: true,
      label: "name",
      field: "_id",
      align: "left",
      type: "string"
    },
    {
      name: "marketHashName",
      required: true,
      label: "marketHashName",
      field: "marketHashName",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "providerItemId",
      required: true,
      label: "providerItemId",
      field: "providerItemId",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "partnerItemId",
      required: true,
      label: "partnerItemId",
      field: "partnerItemId",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "provider",
      required: true,
      label: "provider",
      field: "provider",
      align: "center",
      type: "string",
      editable: false
    },
    {
      name: "soldPrice_RUB",
      required: false,
      label: "soldPrice_RUB",
      field: "soldPrice_RUB",
      align: "right",
      type: "number"
    },
    {
      name: "soldPrice_USD",
      required: false,
      label: "soldPrice_USD",
      field: "soldPrice_USD",
      align: "right",
      type: "number"
    },
    {
      name: "buyPrice",
      required: false,
      label: "buyPrice",
      field: "buyPrice",
      align: "right",
      type: "number"
    },
    {
      name: "appId",
      required: true,
      label: "appId",
      field: "appId",
      align: "right",
      type: "number",
      editable: false
    },
    {
      name: "phase",
      required: false,
      label: "phase",
      field: "phase",
      align: "left",
      type: "string"
    },
    {
      name: "offerId",
      required: false,
      label: "offerId",
      field: "offerId",
      align: "left",
      type: "string"
    },
    {
      name: "partnerSteamId",
      required: false,
      label: "partnerSteamId",
      field: "partnerSteamId",
      align: "left",
      type: "string"
    },
    {
      name: "partnerUserId",
      required: false,
      label: "partnerUserId",
      field: "partnerUserId",
      align: "left",
      type: "string"
    },
    {
      name: "assetId",
      required: true,
      label: "assetId",
      field: "assetId",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "botId",
      required: true,
      label: "botId",
      field: "botId",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "createdAt",
      align: "center",
      label: "createdAt",
      field: "createdAt",
      type: "string"
    },
    {
      name: "updatedAt",
      align: "center",
      label: "updatedAt",
      field: "updatedAt",
      type: "string"
    }
  ];

  get lastSelected() {
    return _.last(this.selected) || null;
  }
}
